import * as React from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useSnackbar } from 'notistack';
import { Grid } from '@mui/material';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import Input from '@mui/material/Input';
import InputAdornment from '@mui/material/InputAdornment';
import SyncLockIcon from '@mui/icons-material/SyncLock';
import useSubmitLock from '../../hooks/useSubmitLock';
const { REACT_APP_API_URL } = process.env;

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

export interface DialogTitleProps {
    id: string;
    children?: React.ReactNode;
    onClose: () => void;
}

function BootstrapDialogTitle(props: DialogTitleProps) {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
}

export default function CambiarPass(props) {
    const { enqueueSnackbar } = useSnackbar();
    const [open, setOpen] = React.useState(false);
    const [datauser, setDaraUser] = React.useState({
        nombre: '',
        apellido: '',
        email: '',
        password: '',
        password2: ''
    })
    const { obteneruser } = props
    const [showPassword, setShowPassword] = React.useState(false);
    const { submitting, runWithSubmitLock } = useSubmitLock();

    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };

    const handleClickVariant = (resultado) => {
        const variant = resultado.variant
        const msg = resultado.errores || resultado.msg
        enqueueSnackbar(msg, { variant });
    };


    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
    };

    const adduser = (e) => {
        e.preventDefault()
        runWithSubmitLock(async () => {
        if (datauser.password === datauser.password2) {

            const token = sessionStorage.getItem('%t')
            var myHeaders = new Headers();
            myHeaders.append("Authorization", `Bearer ${token}`);
            myHeaders.append("Content-Type", "application/json");

            var raw = JSON.stringify({
                "guid": props.guid,
                "password": datauser.password
            });

            var requestOptions = {
                method: 'PATCH',
                headers: myHeaders,
                body: raw,
                redirect: 'follow'
            };
            try {
                const response = await fetch(`${REACT_APP_API_URL}/usuarios/password`, requestOptions)
                const resultado = await response.json();
                return (setDaraUser({}), handleClickVariant(resultado), setOpen(false), obteneruser())
            } catch (error) {
                console.log('Algo salio mal', error);
            }
        } else (
            console.log('Dato no esta completo')
        )
        })
    }


    return (
        <>
            <IconButton aria-label="" onClick={handleClickOpen}>
                <SyncLockIcon />
            </IconButton>

            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open}
                maxWidth='lg'
            >

                <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
                    Actualizar password
                </BootstrapDialogTitle>
                <form onSubmit={adduser}>
                    <DialogContent dividers>


                        <Grid container spacing={2}>

                            <Grid item>
                                <FormControl sx={{ m: 1, width: '25ch' }} variant="standard">
                                    <InputLabel htmlFor="standard-adornment-password">Contraseña</InputLabel>
                                    <Input
                                        required
                                        onChange={e => setDaraUser({ ...datauser, password: e.target.value })}
                                        id="standard-adornment-password"
                                        type={showPassword ? 'text' : 'password'}
                                        endAdornment={
                                            <InputAdornment position="end">
                                                <IconButton
                                                    aria-label="toggle password visibility"
                                                    onClick={handleClickShowPassword}
                                                    onMouseDown={handleMouseDownPassword}
                                                >
                                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                                </IconButton>
                                            </InputAdornment>
                                        }
                                    />
                                </FormControl>
                                <FormHelperText>8 caracteres*</FormHelperText>
                            </Grid>
                            <Grid item>
                                <FormControl sx={{ m: 1, width: '25ch' }} variant="standard">
                                    <InputLabel htmlFor="standard-adornment-password">Repite la contraseña</InputLabel>
                                    <Input
                                        required
                                        onChange={e => setDaraUser({ ...datauser, password2: e.target.value })}
                                        error={datauser.password === datauser.password2 ? null : true}
                                        id="standard-adornment-password2"
                                        type={showPassword ? 'text' : 'password'}
                                        endAdornment={
                                            <InputAdornment position="end">
                                                <IconButton
                                                    aria-label="toggle password visibility"
                                                    onClick={handleClickShowPassword}
                                                    onMouseDown={handleMouseDownPassword}
                                                >
                                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                                </IconButton>
                                            </InputAdornment>
                                        }
                                    />
                                </FormControl>
                                <FormHelperText>8 caracteres*</FormHelperText>
                            </Grid>
                        </Grid>

                    </DialogContent>
                    <Grid container justifyContent='flex-end' alignItems='flex-end' spacing={2} style={{ padding: '9px' }}>
                        <Grid item >
                            <Button autoFocus color='success' variant='outlined' type='submit' disabled={submitting}>
                                Actualizar
                            </Button>
                        </Grid>
                    </Grid>

                </form>


            </BootstrapDialog>
        </>
    );
}